














































import { defineComponent, onBeforeMount } from '@vue/composition-api';

import { useSchedule } from '@/composition-functions/useSchedule';

import CommonTable from '@/components/CommonTable.vue';
import ScheduleCreateForm from '@/components/Schedule/ScheduleCreateForm.vue';
import ScheduleEditForm from '@/components/Schedule/ScheduleEditForm.vue';

export default defineComponent({
  name: 'ScheduleList',

  components: {
    CommonTable,
    ScheduleCreateForm,
    ScheduleEditForm,
  },

  setup () {
    const {
      scheduleList,
      createDialog,
      editDrawer,
      tempSchedule,
      userList,
      fetchSchedules,
      createSchedule,
      toggleEditEventHandler,
      cloeEditFormEventHandler,
      fetchUsers,
      editScheduleEventHandler,
    } = useSchedule();

    onBeforeMount(async () => {
      await fetchSchedules();
      await fetchUsers();
    });

    return {
      scheduleList,
      editDrawer,
      tempSchedule,
      userList,
      createDialog,
      createSchedule,
      toggleEditEventHandler,
      cloeEditFormEventHandler,
      editScheduleEventHandler,
    };
  }
});
